module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/organisation-profile/lwf/lwf-form/lwf-form.component.css
// module id = ./src/app/hrms/payroll/organisation-profile/lwf/lwf-form/lwf-form.component.css
// module chunks = main